<template>
  <div>
    <!-- -------------------------Evaluaciones "Mis Clases" Profesor------------------------- -->
    <Card
      v-if="user && user.group_names.includes('PROFESORES')"
      class="dashboard-card"
      :hide_title="hide_title"
    >
      <template v-slot:title>
        <div class="container-title-my-classes">
          <div>
            <b-icon class="card-header-icon" icon="journal-text"></b-icon>
            {{ $t("dashboard.dashboardView.pastClasses") }}
          </div>
        </div>
      </template>
      <template v-slot:content>
        <template v-if="institution && institution.kl_assessment">
          <div
            v-if="
              sections_teacher.length != 0 ||
              optionsPeriodCurrentSectionTeacher.length > 1 ||
              optionsCareerCurrentSectionTeacher.length > 1 ||
              optionsCampuCurrentSectionTeacher.length > 1 ||
              optionsMatterCurrentSectionTeacher.length > 1
            "
            class="container-select mb-2 noprint"
          >
            <div>
              <b-form-select
                id="input-campus"
                class="select-form"
                v-model="select_campus_current_section_teacher"
                :options="optionsCampuCurrentSectionTeacher"
                @change="getSectionsTeacher()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-career"
                class="select-form"
                v-model="select_career_current_section_teacher"
                :options="optionsCareerCurrentSectionTeacher"
                @change="getSectionsTeacher()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-matter"
                class="select-form"
                v-model="select_matter_current_section_teacher"
                :options="optionsMatterCurrentSectionTeacher"
                @change="getSectionsTeacher()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-period"
                class="select-form"
                v-model="select_period_current_section_teacher"
                :options="optionsPeriodCurrentSectionTeacher"
                @change="getSectionsTeacher()"
              ></b-form-select>
            </div>
          </div>
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              sections_teacher.length > 0
            "
          >
            <b-table-simple
              borderless
              small
              hover
              sticky-header="400px"
              class="border-table"
            >
              <b-thead>
                <b-tr>
                  <b-th class="primary-cell-my-classes" style="width: 14%">{{
                    $getVisibleNames("mesh.campus", false, "Sede")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 25%">{{
                    $getVisibleNames("mesh.career", false, "Programa")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 25%">{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    )
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 15%">{{
                    $getVisibleNames("teaching.section", false, "Sección")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 10%">{{
                    $getVisibleNames("mesh.period", false, "Periodo")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 10%">
                    {{ $t("dashboard.dashboardView.teachers") }}
                  </b-th>
                  <b-th
                    class="primary-cell-my-classes noprint"
                    style="width: 5%"
                    >{{ $t("dashboard.dashboardView.options") }}</b-th
                  >
                </b-tr>
              </b-thead>

              <b-tbody>
                <template v-for="section in sections_teacher">
                  <b-tr
                    v-for="sectionMatter in section.sections"
                    :key="
                      'past-section-teacher-period' +
                      section.period_id +
                      '-section-' +
                      sectionMatter.id
                    "
                  >
                    <!-- Nombre del Campus -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatter.campus_name }}
                    </b-td>
                    <!-- Nombre de la Carrera -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatter.career_name }}
                    </b-td>
                    <!-- Nombre de la Asignatura -->
                    <b-td class="secondary-cell-my-classes">
                      <div class="d-flex container-matter-my-classes">
                        <div
                          v-if="sectionMatter.egress_profile_matter_id != null"
                          class="text-left div-href-test"
                          v-b-tooltip.v-secondary.top.noninteractive="{
                            title:
                              institution &&
                              institution.internal_use_id == 'duoc.cl'
                                ? $t('dashboard.dashboardView.goToPDATeacher')
                                : $t(
                                    'dashboard.dashboardView.goToEntityProgram',
                                    {
                                      entity: $getVisibleNames(
                                        'manual.matter_program',
                                        false,
                                        'Programa de Asignatura'
                                      ),
                                    }
                                  ),
                            boundary: 'viewport',
                          }"
                          @click="
                            redirectToPDA(
                              sectionMatter.egress_profile_matter_id
                            )
                          "
                        >
                          {{ sectionMatter.matter_code }} -
                          {{ sectionMatter.matter_name }}
                        </div>
                        <div v-else class="mr-0">
                          {{ sectionMatter.matter_code }} -
                          {{ sectionMatter.matter_name }}
                        </div>
                      </div>
                    </b-td>
                    <!-- Nombre de la Sección -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatter.name }}
                    </b-td>
                    <!-- Nombre del Periodo -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ section.period_name }}
                    </b-td>
                    <!-- Docentes -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatter.professors.join(", ") }}
                    </b-td>
                    <!-- Opciones -->
                    <b-td
                      class="secondary-cell-my-classes noprint"
                      style="text-align: -webkit-center"
                    >
                      <!-- Botón 3 puntos que abre popover -->
                      <div>
                        <ButtonWrapper :item_id="sectionMatter.id">
                          <template v-slot:btn-slot>
                            <div class="container-btn-three-dots">
                              <b-button
                                variant="secondary"
                                @click="redirectToSection(sectionMatter.id)"
                                class="btn-popover-my-classes mb-2 w-100"
                              >
                                {{
                                  $t("dashboard.dashboardView.notesOf", {
                                    entity: $getVisibleNames(
                                      "teaching.section",
                                      false,
                                      "Sección"
                                    ),
                                  })
                                }}</b-button
                              >
                              <b-button
                                v-if="
                                  institution &&
                                  institution.kl_assessment &&
                                  institution.show_kl_reports
                                "
                                variant="secondary"
                                class="btn-popover-my-classes mb-2 w-100"
                                @click="
                                  redirectToAssessmentStudent(sectionMatter.id)
                                "
                                >{{
                                  $t(
                                    "dashboard.dashboardView.assessmentPerStudent"
                                  )
                                }}
                              </b-button>
                              <b-button
                                variant="secondary"
                                @click="
                                  redirectToEvaluationTeacher(sectionMatter.id)
                                "
                                class="btn-popover-my-classes mb-2 w-100"
                              >
                                {{
                                  $t(
                                    "dashboard.dashboardView.entityOfEntity2",
                                    {
                                      entity1: $getVisibleNames(
                                        "evaluations2.evaluation",
                                        true,
                                        "Evaluaciones"
                                      ),
                                      entity2: $getVisibleNames(
                                        "teaching.section",
                                        false,
                                        "Sección"
                                      ),
                                    }
                                  )
                                }}</b-button
                              >
                              <b-button
                                v-if="
                                  institution && institution.show_kl_reports
                                "
                                variant="secondary"
                                @click="
                                  redirectToAssessmentRange(sectionMatter.id)
                                "
                                class="btn-popover-my-classes mb-2 w-100"
                              >
                                {{
                                  $t("dashboard.dashboardView.assessmentReport")
                                }}
                              </b-button>
                              <b-button
                                v-if="
                                  institution && institution.show_kl_reports
                                "
                                variant="secondary"
                                @click="
                                  redirectToProgressionEvaluation(
                                    sectionMatter.id
                                  )
                                "
                                class="btn-popover-my-classes w-100"
                              >
                                {{
                                  $t("dashboard.dashboardView.progressionOf", {
                                    entity: $getVisibleNames(
                                      "evaluations2.evaluation",
                                      true,
                                      "Evaluaciones"
                                    ),
                                  })
                                }}
                              </b-button>
                            </div>
                          </template>
                        </ButtonWrapper>
                        <!-- <b-button
                          variant="secondary"
                          size="sm"
                          :id="`popover-my-classes-teacher-${sectionMatter.id}`"
                          class="btn-three-dots"
                        >
                          <b-icon icon="three-dots"> </b-icon>
                        </b-button> -->
                      </div>
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </template>
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              sections_teacher.filter((x) => x.sections.length > 0).length == 0
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.noEntityToShow", {
                  entity: $getVisibleNames(
                    "teaching.section",
                    true,
                    "Secciones"
                  ),
                })
              }}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-left">
            <span>{{ $t("dashboard.dashboardView.moduleNotEnabled") }}</span>
          </div>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "PastSectionTeacher",
  components: {
    Card: () => import("@/components/users/Card"),
    ButtonWrapper: () => import("@/components/reusable/ButtonWrapper"),
  },
  props: {
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      first_fetch_current_section_teacher: true,
      select_period_current_section_teacher: null,
      select_career_current_section_teacher: null,
      select_campus_current_section_teacher: null,
      select_matter_current_section_teacher: null,
      sections_teacher: [],
      optionsPeriodCurrentSectionTeacher: [],
      optionsCareerCurrentSectionTeacher: [],
      optionsCampuCurrentSectionTeacher: [],
      optionsMatterCurrentSectionTeacher: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
  },
  methods: {
    redirectToPDA(egress_profile_matter_id) {
      if (this.institution && this.institution.internal_use_id == "duoc.cl")
        this.$router.push({
          name: "LearningSuitcaseTeacherView",
          params: {
            egress_profile_matter_id: egress_profile_matter_id,
          },
        });
      else {
        this.$router.push({
          name: "MatterProgramView",
          params: {
            matter_id: egress_profile_matter_id,
          },
        });
      }
    },
    redirectToAssessmentStudent(id) {
      this.$router.push({
        name: "AssessmentStudentsView",
        params: {
          section_id: id,
        },
      });
    },
    optionsCareersCurrentSection(careersFromApi) {
      this.optionsCareerCurrentSectionTeacher = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.career", false, "Carrera"),
          }),
        },
      ];
      // Crear un Map para almacenar carreras únicas
      const uniqueCareers = new Map();
      // Iterar sobre los datos de la API y llenar el Map
      careersFromApi.forEach((x) => {
        x.sections.forEach((y) => {
          if (y.career_name && !uniqueCareers.has(y.career_name)) {
            uniqueCareers.set(y.career_name, y.career_id);
          }
        });
      });
      // Convertir el Map en un array de opciones y añadirlo a optionsPeriodCurrentSectionTeacher
      uniqueCareers.forEach((id, name) => {
        this.optionsCareerCurrentSectionTeacher.push({
          value: id,
          text: name,
        });
      });
    },
    optionsPeriodCurrentSection(periodsFromApi) {
      this.optionsPeriodCurrentSectionTeacher = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.period", false, "Período"),
          }),
        },
      ];
      const uniquePeriods = new Map();

      periodsFromApi.forEach((x) => {
        if (!uniquePeriods.has(x.period_name)) {
          uniquePeriods.set(x.period_name, x.period_id);
        }
      });
      uniquePeriods.forEach((id, name) => {
        this.optionsPeriodCurrentSectionTeacher.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCampusCurrentSection(campusFromApi) {
      this.optionsCampuCurrentSectionTeacher = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.campus", false, "Sede"),
          }),
        },
      ];
      const uniqueCampus = new Map();
      campusFromApi.forEach((x) => {
        x.sections.forEach((y) => {
          if (y.campus_name && !uniqueCampus.has(y.campus_name)) {
            uniqueCampus.set(y.campus_name, y.campus_id);
          }
        });
      });
      uniqueCampus.forEach((id, name) => {
        this.optionsCampuCurrentSectionTeacher.push({
          value: id,
          text: name,
        });
      });
    },
    optionsMatterCurrentSection(mattersFromApi) {
      this.optionsMatterCurrentSectionTeacher = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
          }),
        },
      ];
      const uniqueMatter = new Map();
      mattersFromApi.forEach((x) => {
        x.sections.forEach((y) => {
          if (y.matter_name && !uniqueMatter.has(y.matter_name)) {
            uniqueMatter.set(y.matter_name, y.matter_id);
          }
        });
      });
      uniqueMatter.forEach((id, name) => {
        this.optionsMatterCurrentSectionTeacher.push({
          value: id,
          text: name,
        });
      });
    },
    redirectToSection(id) {
      this.$router.push({
        name: "NewFullGradingView",
        params: {
          section_id: id,
        },
      });
    },
    redirectToEvaluationTeacher(id) {
      this.$router.push({
        name: "EvaluatorEvaluationsListView",
        params: {
          section_id: id,
        },
      });
    },
    redirectToAssessmentRange(id) {
      this.$router.push({
        name: "AssessmentRangeSectionView",
        params: {
          section_id: id,
        },
      });
    },
    redirectToProgressionEvaluation(id) {
      this.$router.push({
        name: "ProfessorProgressionReportView",
        params: {
          section_id: id,
        },
      });
    },
    getSectionsTeacher() {
      if (
        this.user &&
        this.user.group_names.includes("PROFESORES") &&
        this.institution &&
        this.institution.kl_assessment
      ) {
        let arr = [];

        if (this.select_campus_current_section_teacher != null)
          arr.push("campus=" + this.select_campus_current_section_teacher);
        if (this.select_career_current_section_teacher != null)
          arr.push("career=" + this.select_career_current_section_teacher);
        if (this.select_period_current_section_teacher != null)
          arr.push("period=" + this.select_period_current_section_teacher);
        if (this.select_matter_current_section_teacher != null)
          arr.push("matter=" + this.select_matter_current_section_teacher);

        let partial_url = "";
        if (arr.length > 0) partial_url = "?" + arr.join("&");

        this.$restful
          .Get(`/evaluations2/dashboard_teacher_sections/${partial_url}`)
          .then((response) => {
            this.sections_teacher = response.filter(
              (x) => !x.is_current_period
            );
            this.$emit(
              "count",
              this.sections_teacher.reduce(
                (acc, s) => acc + s.sections.length,
                0
              )
            );
            if (this.first_fetch_current_section_teacher) {
              this.optionsPeriodCurrentSection(this.sections_teacher);
              this.optionsCareersCurrentSection(this.sections_teacher);
              this.optionsCampusCurrentSection(this.sections_teacher);
              this.optionsMatterCurrentSection(this.sections_teacher);
              this.first_fetch_current_section_teacher = false;
            }
          });
      }
    },
  },
  mounted() {
    this.getSectionsTeacher();
  },
  watch: {
    user() {
      this.getSectionsTeacher();
    },
    institution() {
      this.getSectionsTeacher();
    },
  },
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped>
.container-title-my-classes {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
.card-header-icon {
  margin-right: 0.35em;
}
.border-table {
  border-radius: var(--kl-radius-lg);
  border: 1px solid var(--kl-border);
  max-height: calc(100vh - 290px) !important;
  overflow-y: auto;
}
.border-table >>> table {
  margin-bottom: 0;
}
.border-table >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-surface-muted);
}
.border-table >>> tbody tr:hover > td {
  background-color: var(--kl-surface-hover);
}
.primary-cell-my-classes {
  text-align: left;
  vertical-align: middle;
  background: var(--kl-color-accent-soft) !important;
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border-bottom: none !important;
  white-space: nowrap;
}
.secondary-cell-my-classes {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 11px 12px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
.div-href-test {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.div-href-test:hover {
  color: var(--kl-color-primary-deep) !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-btn-three-dots {
  max-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.btn-three-dots {
  border-radius: 50%;
  padding: 2.5px 3px;
}
.btn-popover-my-classes {
  padding: 8px 12px !important;
  font-size: var(--kl-fs-body);
  border-radius: 9px !important;
  background: var(--kl-bg-page) !important;
  color: var(--kl-text-heading) !important;
  border: 1px solid var(--kl-border-soft) !important;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.btn-popover-my-classes:hover {
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  color: #ffffff !important;
  border-color: transparent !important;
}
.container-select {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.container-select > div {
  flex: 1 1 calc(25% - 10px);
  min-width: 200px;
}
.select-form {
  width: 100%;
  height: 40px;
  font-size: var(--kl-fs-body);
  color: var(--kl-text-heading);
  border: 1px solid var(--kl-border-soft) !important;
  border-radius: var(--kl-input-radius) !important;
  background-color: var(--kl-surface);
}
.select-form:focus {
  border-color: var(--kl-color-primary) !important;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15) !important;
}
@media (max-width: 992px) {
  .container-select > div {
    flex: 1 1 calc(50% - 10px);
  }
}
@media (max-width: 576px) {
  .container-select > div {
    flex: 1 1 100%;
  }
}
@media print {
  .secondary-cell-my-classes {
    background-color: transparent !important;
  }
}
</style>